const d3_scale = require('d3-scale');
const d3_array = require('d3-array');

/**
 * Returns a D3 color scale (linear or diverging as specified) based on the data in a selected field in the data.
 */
export function calculateColorScale(data, selectedVar, colorArray, type) {
  if (type === 'linear') {
    return d3_scale.scaleLinear()
		.domain([
			0,
			d3_array.max(data, function(d) { return d[selectedVar]; })
		])
		.range(colorArray);

  } else if (type === 'diverging') {
    let ends = Math.max(Math.abs(d3_array.min(data, function(d) { return d[selectedVar]; })), Math.abs(d3_array.max(data, function(d) { return d[selectedVar]; })))

    return d3_scale.scaleDiverging()
		.domain([
      -ends, 0, ends
		])
		.range(colorArray);
  }
}

/**
 * Uses a D3 color scale to color a Mapbox chloropleth using Mapbox GL match expressions.
 */
export function setChoroplethColor(map, layer, data, selectedVar, colorScale) {
  let matchExpression;

  // GL match expression to assign color to the matching county ID (the indicated spatial data variable)
  matchExpression = ['match', ['get', 'geoid']]

  //Pull the right value out the D3 color scale for each geo feature. Build up the match expression.
  data.forEach(function (d) {
    d.fips = String(d.geoid);
    let color;
    if (d[selectedVar] !== null) { 
      color = colorScale(d[selectedVar]); 
    } else {
      color = 'rgb(187, 187, 187)' // NULL color
    }
    matchExpression.push(d['geoid'], color);
  });

  //Last value is default, used where there is no data.
  matchExpression.push('rgb(	248, 219, 219)');

  //Set the paint color for each feature
  map.setPaintProperty(
    layer,
    'fill-color',
    matchExpression
  );
}

/**
 * Combine multiple bounding boxes to one larger bounding box.
 */
export function mergedBBox (boundingBoxes) {
  let minLeft = 180;
  let minBottom = 90;
  let maxRight = -180;
  let maxTop = -90;

  boundingBoxes.forEach(([left, bottom, right, top]) => {
    if (left < minLeft) minLeft = left;
    if (bottom < minBottom) minBottom = bottom;
    if (right > maxRight) maxRight = right;
    if (top > maxTop) maxTop = top;
  })

  return [minLeft, minBottom, maxRight, maxTop]
}

export const unique_colors = [ //Tableau 10. See https://observablehq.com/@hamzaamjad/color-palettes
  "#a9c9e6", // light blue (instead of aqua #76b7b2)
  "#4e79a7", // darker blue
  "#b07aa1", // purple
  "#e15759", // darker red
  "#BFBFBD", // grey (lightened from #bab0ac)
  '#f28e2b', // orange
  "#59a14f", // green
  '#9c755f', // brown
  '#edc948', // yellow
  '#4C4E52', // dark grey (added)
  '#ff9da7', // pink
]
